import React from 'react'
import PropTypes from 'prop-types'

import { Close, Coin, CoinIcon } from './Svg'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  render() {
    const { user, title, lk_link } = this.props

    return (
      <div className='flex items-center justify-between pt-[10px]'>
        <a href="/" className="flex-none w-[40px] h-[40px] rounded-full bg-white flex items-center justify-center cursor-pointer">
          <Close />
        </a>
        <div className='text-center font-manrope text-[22px] text-black font-semibold'>
          {title}
        </div>
        <a href={lk_link} className='flex-none flex items-center justify-center flex-col'>
          <Coin />
          <div className='w-[35px] h-[15px] bg-[#A6DD2F] flex gap-[2px] items-center justify-center rounded-full mt-[-8px] z-10'>
            <div className='text-white text-[10px]'>{user?.coin}</div>
            <CoinIcon />
          </div>
        </a>
      </div>
    )
  }
}

Main.propTypes = {
  user: PropTypes.object,
  title: PropTypes.string,
  lk_link: PropTypes.string
}

export default Main